import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Article as ArticleIcon } from '@mui/icons-material';
import { getAllBlogs, deleteBlog } from '../../api/blogApi';
import { GenericListPage } from '../../components/templates';

const BlogList = () => {
  const columns = [
    {
      field: 'title',
      headerName: 'Title',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'slug',
      headerName: 'Slug',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ color: 'text.secondary', fontFamily: 'monospace' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'metaTags',
      headerName: 'Tags',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const tags = Array.isArray(params.value)
          ? params.value
          : (params.value || '').split(',').map((t) => t.trim()).filter(Boolean);
        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {tags.slice(0, 3).map((tag) => (
              <Chip key={tag} label={tag} size="small" color="primary" variant="outlined" />
            ))}
            {tags.length > 3 && (
              <Chip label={`+${tags.length - 3}`} size="small" color="default" variant="outlined" />
            )}
          </Box>
        );
      },
    },
  ];

  const transformData = (response) => {
    return response.blogs || response;
  };

  return (
    <GenericListPage
      title="Blog Management"
      subtitle="Create and manage blog posts and articles"
      icon={<ArticleIcon />}
      entityName="Blog"
      columns={columns}
      fetchData={getAllBlogs}
      deleteItem={deleteBlog}
      createPath="/blogs/new"
      editPath="/blogs"
      transformData={transformData}
    />
  );
};

export default BlogList;
